"use client";

import UnicornScene from "unicornstudio-react/next";

export function HeroBackground() {
  return (
    <div className="absolute inset-x-0 top-0 z-0 h-dvh" aria-hidden="true">
      <UnicornScene
        projectId="V4VM6A36r105T59uEVXI"
        scale={1}
        dpi={1}
        fps={30}
        lazyLoad={false}
        production
        className="h-full w-full"
        onError={e => console.error("[HeroBackground] Unicorn scene failed", e)}
      />
    </div>
  );
}
